<template>
    <div ref="top">
        <template v-if="paginatedData.length > 0">
            <safety-data-sheet-item v-for="(item, index) in paginatedData" :key="index" :datasheet="item" />
        </template>
        <template v-else>
            <div class="text-center">
                <p class="text-cod-gray">No matches found.</p>
            </div>
        </template>

        <div class="safty-data-pagination" v-if="pageCount > 1">
            <navigation class="pagination">
                <paginate :pageCount="pageCount" :clickHandler="onPageChange" :hidePrevNext="true" prevClass="prev" nextClass="next" pageClass="link" />
            </navigation>
        </div>
    </div>
</template>
<script>
import { isEmpty, isNull } from 'lodash'
import Paginate from 'vuejs-paginate'
export default {
    components: {
        Paginate,
    },
    mounted() {
        this.fetch()

        events.subscribe('datasheet.search', (payload) => {
            this.category = null
            this.sort = false
            this.currentPage = 1
            this.searchQuery = payload.query
        })

        events.subscribe('datasheet.filters', (payload) => {
            this.searchQuery = null

            switch (payload.type) {
                case 'category':
                    this.sort = false
                    this.category = payload.value
                    break
                case 'type':
                    this.sort = true
                    break
            }
        })
    },
    data: () => ({
        perPage: 10,
        currentPage: 1,
        searchQuery: null,
        category: null,
        sort: false,
        filtered: {},
    }),
    computed: {
        items() {
            const items = this.$store.state.safetyDataSheets.items.products
            const dataSheets = items.reduce((sheets, item) => {
                if (item.datasheets.length) {
                    Array.prototype.push.apply(sheets, item.datasheets)
                }
                return sheets
            }, [])
        
            return dataSheets
        },
        pageCount() {
            return Math.ceil(this.filtered.length / this.perPage)
        },
        paginatedData() {
            this.filtered = this.items

            if (!isEmpty(this.searchQuery)) {
                this.filtered = this.items.filter((item) => {
                    return item.name.toLowerCase().includes(this.searchQuery.toLowerCase())
                })
            }

            if (!isNull(this.category)) {
                this.filtered = this.items.filter((item) => {
                    return item.category.toLowerCase() === this.category.toLowerCase()
                })
            }

            if (this.sort) {
                this.filtered = this.items.sort((a, b) => {
                    return a.type.toLowerCase() > b.type.toLowerCase() ? 1 : -1
                })
            }

            const start = (this.currentPage - 1) * this.perPage
            const end = this.currentPage * this.perPage
            return this.filtered.slice(start, end)
        },
    },
    methods: {
        async fetch() {
            await this.$store.dispatch('safetyDataSheets/FETCH')
        },
        onPageChange(value) {
            this.currentPage = value
            window.scrollTo({top: this.$refs['top'].offsetTop - 100, behavior: 'smooth'})
        },
    },
}
</script>
